module.exports = __webpack_public_path__ + "img/WALES.726ffb44.svg";